import { render, staticRenderFns } from "./daily-cargo-list.vue?vue&type=template&id=b8bf6fd6"
import script from "./daily-cargo-list.vue?vue&type=script&lang=js"
export * from "./daily-cargo-list.vue?vue&type=script&lang=js"
import style0 from "./daily-cargo-list.vue?vue&type=style&index=0&id=b8bf6fd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports